import configJSON from "./config.json"

export const ENV =
  configJSON.KOSMOS_UI_CONFIG_ENVIRONMENT || process.env.NODE_ENV
export const RELEASE = configJSON.KOSMOS_UI_CONFIG_APP_RELEASE

export const isDev = ENV === "development"

// Firebase ENV variables
export const FIREBASE_API_KEY = configJSON.KOSMOS_UI_CONFIG_FIREBASE_API_KEY
export const FIREBASE_AUTH_DOMAIN =
  configJSON.KOSMOS_UI_CONFIG_FIREBASE_AUTH_DOMAIN

// Loggers ENV variables
export const SENTRY_DSN = configJSON.KOSMOS_UI_CONFIG_SENTRY_DSN || ""
export const MIXPANEL_TOKEN = configJSON.KOSMOS_UI_CONFIG_MIXPANEL_TOKEN || ""
export const MIXPANEL_PROXY_URL =
  configJSON.KOSMOS_UI_CONFIG_MIXPANEL_PROXY_URL || ""

export const INTERCOM_APP_ID =
  typeof window === "undefined" ? "" : (window as any).APP_ID_INTERCOM || ""

// E2E ENV variables
export const isE2E = ENV === "e2e"

//recaptcha env variables
export const RECAPTCHA_SITE_KEY =
  configJSON.KOSMOS_UI_CONFIG_RECAPTCHA_SITE_KEY || ""

// Set by the self-hosted chart; envsubst leaves the "$KOSMOS_UI_CONFIG_…" placeholder when it isn't
export const INTEGRATIONS_GATEWAY_URL =
  configJSON.KOSMOS_UI_CONFIG_INTEGRATIONS_GATEWAY_URL?.startsWith("https://")
    ? configJSON.KOSMOS_UI_CONFIG_INTEGRATIONS_GATEWAY_URL
    : "https://integrations.kodemsecurity.com"

// The public API host MCP clients connect to: set per deployment by the chart (KOSMOS_UI_CONFIG_API_URL; envsubst
// leaves its "$KOSMOS_UI_CONFIG_API_URL" placeholder when it isn't), else Kodem's
export const API_URL = configJSON.KOSMOS_UI_CONFIG_API_URL?.startsWith(
  "https://"
)
  ? configJSON.KOSMOS_UI_CONFIG_API_URL.replace(/\/+$/, "")
  : "https://api.kodemsecurity.com"

export const E2E = {
  USERNAME: configJSON.KOSMOS_UI_E2E_USERNAME,
  PASSWORD: configJSON.KOSMOS_UI_E2E_PASSWORD
}

export const SELF_HOSTED:
  | false
  | {
      microKosmosVersion: string
      slug: string
    } =
  configJSON.KOSMOS_UI_CONFIG_ENVIRONMENT?.trim() === "selfhosted"
    ? {
        microKosmosVersion: configJSON.KOSMOS_UI_CONFIG_MICRO_KOSMOS_VERSION,
        slug: configJSON.KOSMOS_UI_CONFIG_SELF_HOSTED_SLUG
          ? configJSON.KOSMOS_UI_CONFIG_SELF_HOSTED_SLUG
          : "kodem"
      }
    : false
